import { TraceabilityProducer } from './traceability-producer.model'

export class TraceabilityReception {
  /** Reception ID */
  id: string

  /** Crop's code */
  crop: string

  /** External traceability code */
  traceCode: string

  /** origin **/
  orig?: string

  producer: TraceabilityProducer

  constructor(reception?: TraceabilityReception) {
    this.id = reception.id || ''
    this.crop = reception.crop || ''
    this.traceCode = reception.traceCode || ''
    this.orig = reception.orig || ''
    this.producer = new TraceabilityProducer(reception.producer)
  }
}
